"use client";

import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import { Alert, Button, Stack } from "@mui/material";

export interface LoadErrorStateProps {
  message: string;
  retryLabel: string;
  onRetry: () => void;
  isRetrying?: boolean;
  /** `center` fills and centers within its container. */
  align?: "start" | "center";
}

export const LoadErrorState = ({
  message,
  retryLabel,
  onRetry,
  isRetrying = false,
  align = "start",
}: LoadErrorStateProps): React.JSX.Element => {
  const centered = align === "center";

  return (
    <Stack
      sx={{
        alignItems: centered ? "center" : "flex-start",
        flex: centered ? 1 : undefined,
        gap: 2,
        justifyContent: "center",
        padding: centered ? 4 : 0,
      }}
    >
      <Alert severity="error">{message}</Alert>
      <Button
        disabled={isRetrying}
        onClick={onRetry}
        startIcon={<RefreshRoundedIcon aria-hidden="true" />}
        variant="contained"
      >
        {retryLabel}
      </Button>
    </Stack>
  );
};
